import BackButton from '../../../components/ui-components/BackButton'
import { goBack } from '../../../utils/appBridge'
import { getTopPadding } from '../../../utils/sessionStorage'
import { ElitePlansEventId, trackElitePlansClick } from '../analytics'
import { ELITE_PLANS_ELITE_PRIME_TAB_ID } from '../constants/planIds'
import { useElitePlansIsFromHome } from '../hooks/useElitePlansIsFromHome'
import { PlanSwitcherTabIcon } from './PlanSwitcher'

type ElitePrimeDashboardHeaderProps = {
  title?: string
  planId?: string
  /** Locked Elite routes use Elite header chrome; Prime-locked keep Prime accents. */
  accent?: 'elite' | 'prime'
  /** When false, back button only (no plan-tab icon / title). Elite-locked routes. */
  showPlanTab?: boolean
}

export function ElitePrimeDashboardHeader({
  title = 'Elite Prime',
  planId = ELITE_PLANS_ELITE_PRIME_TAB_ID,
  accent = 'prime',
  showPlanTab = true
}: ElitePrimeDashboardHeaderProps) {
  // Native home embed already has chrome — skip webview header, keep status-bar pad
  const hideHeader = useElitePlansIsFromHome()
  const headerTone =
    accent === 'elite'
      ? 'text-[color:var(--ep-header-ink)] border-b border-b-[color:var(--ep-header-border)]'
      : 'text-prime60 border-b border-b-[rgba(165,86,94,0.10)]'

  const handleBack = () => {
    trackElitePlansClick(ElitePlansEventId.Back)
    goBack()
  }

  if (hideHeader) {
    return (
      <div
        className='ep-theme-tween bg-[color:var(--ep-bg-top)]'
        style={{ paddingTop: `${getTopPadding()}px` }}
        aria-hidden
      />
    )
  }

  return (
    <header
      style={{ paddingTop: `${getTopPadding()}px` }}
      className={`ep-theme-tween sticky top-0 z-30 flex items-center bg-[color:var(--ep-bg-top)] px-3 ${headerTone}`}
    >
      <div className='flex h-11 w-11 shrink-0 items-center justify-center'>
        <BackButton fill='currentColor' size={24} onClick={handleBack} aria-label='Back' />
      </div>
      {showPlanTab ? (
        <div className='flex flex-1 justify-center pr-11'>
          <h1 className='flex min-h-11 items-center justify-center px-1 pb-2 pt-1'>
            <span className='sr-only'>{title}</span>
            <span aria-hidden='true'>
              <PlanSwitcherTabIcon planId={planId} />
            </span>
          </h1>
        </div>
      ) : null}
    </header>
  )
}
